import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * One number in the studio overview. Big figure, small label, hairline box —
 * the owner should read the four of them in about two seconds.
 */
export function StatCard({
  label,
  value,
  hint,
  accent = false,
  className,
}: {
  label: string
  value: ReactNode
  hint?: string
  /** Use for the number that actually needs acting on (new enquiries). */
  accent?: boolean
  className?: string
}) {
  return (
    <div
      data-upbo-type="card"
      data-upbo-label={`Stat — ${label}`}
      className={cn('border border-border rounded-squircle p-5 flex flex-col gap-1.5', className)}
    >
      <span className="text-[10px] uppercase tracking-[0.16em] text-text-faint">{label}</span>
      {/* Figures are set in the sans face on purpose: the display serif's "1"
          reads as an "I", and a stat is a number the owner acts on. */}
      <span
        className={cn(
          'text-[30px] font-light leading-none tabular-nums tracking-tight',
          accent ? 'text-primary' : 'text-text',
        )}
      >
        {value}
      </span>
      {hint && <span className="text-[12px] text-text-muted">{hint}</span>}
    </div>
  )
}
